import { Component, OnInit } from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {AccountInfoService} from '../../user/account-info.service';
import {Router} from '@angular/router';
import {EmailtemplateService} from '../../emailtemplate.service';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';
import {interval} from 'rxjs';

@Component({
  selector: 'app-businesslocations',
  templateUrl: './businesslocations.component.html',
  styleUrls: ['./businesslocations.component.scss']
})
export class BusinesslocationsComponent implements OnInit {

  constructor(public settingComp: SettingsComponent,
              public accountInfoService: AccountInfoService,
              private appComp: AppComponent,
              public platform: LeftpanelComponent,
              public router: Router,
              private adminEnvironmenthandler: AdminEnvironmentHandlerService,
              private partnerSettingsService: PartnerSettingsService) { }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  initialize() {
    const partnerSettingsSubscription = interval(500).subscribe((async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        let environmentData = this.partnerSettingsService.environment;
        if (!environmentData.name.includes('admin')) {
          this.redirect('/console');
        } else {
          this.setData();
        }
        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          environmentData = this.partnerSettingsService.environment;
          if (!environmentData.name.includes('admin')) {
            this.redirect('/console');
          } else {
            this.setData();
          }
        });
      }
    }));
  }

  setData() {
    this.appComp.currentPageTitle = 'Manage Business Locations';
    this.appComp.ribbon = 'Business Locations';
    if (!this.settingComp.item) {
      this.settingComp.setcolumnvalues();
    }
  }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.initialize();
  }

}
